import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {Table} from '..';
import {openModal} from '../../actions';
import {useTableSort} from '../../utils/sortUtilities';
import Spinner from '../Spinner';

const HEAD_CELLS = [
  // {
  //   id: 'cardId',
  //   numeric: false,
  //   disabledPadding: true,
  //   label: 'Card ID',
  // },
  {
    id: 'cardCode',
    numeric: false,
    disabledPadding: false,
    label: 'Card Code',
  },
  {
    id: 'siteCode',
    numeric: false,
    disabledPadding: true,
    label: 'Site_Code',
  },
  {
    id: 'siteNo',
    numeric: false,
    disabledPadding: true,
    label: 'Site_No',
  },
  {
    id: 'customerFirstName',
    numeric: false,
    disabledPadding: true,
    label: 'First Name',
  },
  {
    id: 'customerLastName',
    numeric: false,
    disabledPadding: true,
    label: 'Last Name',
  },
  
  {
    id: 'count',
    numeric: false,
    disabledPadding: true,
    label: 'Times Used',
  },
  {
    id: 'date',
    numeric: false,
    disabledPadding: true,
    label: 'On Date',
  },
  
];

const DATA_CELLS = [ 'cardCode', 'siteCode', 'siteNo', 'customerFirstName', 'customerLastName',  'count', 'date'];

const OverUsedCardsTable = ({overUsedCards, loading, hideAddButton}) => {
  const dispatch = useDispatch();
  const tableOrder = useTableSort('asc', 'createdAt');
//   const onRowClick = item => {
    
//   };
//   const onAddEntrance = () => {
//     dispatch(openModal('AddEntranceModal', {buildingID: buildingById.id}));
//   };

  if (loading) {
    return <Spinner />;
  }

  const formatDate = (date) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(date).toLocaleDateString(undefined, options); // Customize as needed
  };

  return (
    <Table
      data={overUsedCards.map(item => ({
        ...item,
        date: formatDate(item.date) 
      }))}
      dataCells={DATA_CELLS}
      headCells={HEAD_CELLS}
    //   onRowClick={onRowClick}
      onAdd={hideAddButton}
      noToolbar={hideAddButton}
      {...tableOrder}
      style={{ borderCollapse: 'collapse' }}
    />
  );
};

export default OverUsedCardsTable;
